import { render, staticRenderFns } from "./FixedPaymentConditionPill.vue?vue&type=template&id=b60ca268"
import script from "./FixedPaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixedPaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports